import React, { FunctionComponent } from 'react'
import NoLogoIcon from '../../assets/media/logos/no-logo.svg'
import AudiLogoIcon from '../../assets/media/logos/audi-logo.svg'
import CupraLogoIcon from '../../assets/media/logos/cupra-logo.svg'
import ManLogoIcon from '../../assets/media/logos/man-logo.svg'
import SeatLogoIcon from '../../assets/media/logos/seat-logo.svg'
import SeatAndCupraLogoIcon from '../../assets/media/logos/seat-and-cupra-logo.svg'
import SkodaLogoIcon from '../../assets/media/logos/skoda-logo.svg'
import SkodaLogoItIcon from '../../assets/media/logos/skoda-it-logo.svg'
import VwLogoIcon from '../../assets/media/logos/vw-logo.svg'
import VwnLogoDeIcon from '../../assets/media/logos/vwn-de-logo.svg'
import VwnLogoDkIcon from '../../assets/media/logos/vwn-dk-logo.svg'
import VwnLogoFiIcon from '../../assets/media/logos/vwn-fi-logo.svg'
import VwnLogoFrIcon from '../../assets/media/logos/vwn-fr-logo.svg'
import VwnLogoGbIcon from '../../assets/media/logos/vwn-gb-logo.svg'
import VwnLogoNlIcon from '../../assets/media/logos/vwn-nl-logo.svg'
import VwnLogoSeIcon from '../../assets/media/logos/vwn-se-logo.svg'
import style from './logo.css'

export type Props = {
    isHidden: boolean
    brand: string
    country: string
    resetConfiguration: Function
}

const Logo: FunctionComponent<Props> = (props) => {
    const { isHidden, brand, country, resetConfiguration } = props

    const logoMap = {
        audi: AudiLogoIcon,
        cupra: SeatAndCupraLogoIcon,
        cupra_IT: CupraLogoIcon,
        man: ManLogoIcon,
        seat: SeatAndCupraLogoIcon,
        seat_IT: SeatLogoIcon,
        skoda: SkodaLogoIcon,
        skoda_IT: SkodaLogoItIcon,
        vw: VwLogoIcon,
        vwn: VwLogoIcon,
        vwn_DE: VwnLogoDeIcon,
        vwn_DK: VwnLogoDkIcon,
        vwn_ES: NoLogoIcon,
        vwn_FI: VwnLogoFiIcon,
        vwn_FR: VwnLogoFrIcon,
        vwn_GB: VwnLogoGbIcon,
        vwn_IE: VwnLogoGbIcon,
        vwn_NL: VwnLogoNlIcon,
        vwn_SE: VwnLogoSeIcon,
    }

    const clickHandler = (): void => {
        resetConfiguration()
    }

    const brandWithOrWithoutCountry = (logoMap[`${brand}_${country}`] !== undefined)
        ? `${brand}_${country}`
        : brand
    const LogoIcon = logoMap[brandWithOrWithoutCountry]

    const wrapperClassName = [
        style.wrapper,
        style[`wrapper-${brandWithOrWithoutCountry}`],
        isHidden ? style.hidden : '',
    ].join(' ')

    const iconClassName = [
        style.icon,
        style[`icon-${brandWithOrWithoutCountry}`],
    ].join(' ')

    return (
        <div className={wrapperClassName}>
            <button className={style.iconButtonWrapper} onClick={clickHandler} data-testid="logo-button">
                <LogoIcon className={iconClassName} />
            </button>
        </div>
    )
}

export default Logo
